<template>
  <div class="d-flex flex-column justify-content-center align-items-center" style="gap: 5px" v-if="mapsMode && selectedRelease">
    <DT_LatLong
      v-if="mapsMode"
      :map="map"
      :mapsMode="mapsMode"
      :clickedCoords="clickedCoords"
      @addPoint="$emit('addPoint', $event)"
    ></DT_LatLong>
    <DT_Measurement
      v-if="showMeasuringTool" 
      :showSnippingTool="showSnippingTool"
      :showMeasuringTool="showMeasuringTool"
      :measurement="measurement"
      :polygonsSelected="polygonsSelected"
      :user="user"
      :selectedExtent="selectedExtent"
      :polygonVectorLayersLength="polygonVectorLayers.length"
      @clearPolygon="$emit('clearPolygon')"
    ></DT_Measurement>
    <DD_PolygonButtons
      v-if="parseInt(polygonVectorLayers.length) > 0 && !lidarFlag"
      :polygonsSelected="polygonsSelected"
      :user="user"
      :selectedExtent="selectedExtent"
      :polygonVectorLayersLength="polygonVectorLayers.length"
      @clearPolygon="$emit('clearPolygon')"
      @notification="$emit('notification', $event)"
      @admin-notification="$emit('admin-notification', $event)"
    ></DD_PolygonButtons>
    <DT_LidarTiles
      v-if="showLidarPanel"
      :lidarMinZoomAchieved="lidarMinZoomAchieved"
      :showLidarPanel="showLidarPanel"
      :distinct_lidar="distinct_lidar"
      :extentName="selectedExtent"
      :lidarIsLoading="lidarIsLoading"
      :map="map"
      :selectedExtent="selectedExtent"
      :zoomLevel="zoomLevel"
    ></DT_LidarTiles>
    <div v-if="lidarTrailsActive" class="year-filter-anchor">
    <TRT_YearFilter @yearFilterChanged="$emit('yearFilterChanged', $event)" />
    </div>
  </div>
</template>

<script>
import DT_Measurement from './DT_Measurement.vue';
import DT_LatLong from './DT_LatLong.vue';
import DT_LidarTiles from './DT_LidarTiles.vue';
import DD_PolygonButtons from './DD_PolygonButtons.vue';
import TRT_YearFilter from './TRT_YearFilter.vue'
export default {
  name: "DT_Tools",
  props: [
    "map",
    "mapsMode",
    "clickedCoords",
    "showSnippingTool",
    "showMeasuringTool",
    "measurement",
    "polygonsSelected",
    "user",
    "selectedExtent",
    "polygonVectorLayers",
    'selectedRelease',
    'showLidarPanel',
    'zoomLevel',
    'lidarMinZoomAchieved',
    'distinct_lidar',
    'lidarIsLoading',
    'trailsLoading',
    'distinct_trails',
    'showTrailsPanel',
    'selectedTrails',
    'cart',
    'lidarFlag',
    'lidarTrailsActive',
  ],
  components: {
    DT_Measurement,
    DT_LatLong,
    DT_LidarTiles,
    DD_PolygonButtons,
    TRT_YearFilter,
  },
  data() {
    return {
      widgetLeft: '280px',
      _resizeObserver: null
    }
  }, 
  mounted() {
    const sidebar = document.querySelector('.sidebar-navigation');
    if (sidebar) {
      this.widgetLeft = (sidebar.getBoundingClientRect().width + 10) + 'px';
      this._resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          this.widgetLeft = (entry.contentRect.width + 10) + 'px';
        }
      });
      this._resizeObserver.observe(sidebar);
    }
  },
  beforeDestroy() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }
}
</script>

<style scoped>
.year-filter-anchor {
  position: fixed;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}
</style>